import styled from "styled-components";
import React from "react";
import { Col, Row } from "antd";
import ListCardTwo from "../Shared/ListCardTwo";
import UserItem from "../Shared/UserItem";
import ListCard from "../Shared/ListCard";

const Audience: React.FC = (props) => {
  // const location = useLocation();
  return (
    <Wrapper>
      <div className="tabs-content-wrapper padding-bottom-lg">
        <h3>Top Accounts</h3>
        <Row gutter={52}>
          <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
            <ListCard />
          </Col>
          <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
            <ListCard />
          </Col>
          <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
            <ListCard />
          </Col>
          <Col className="gutter-row" xs={18} sm={12} md={8} lg={6} xxl={4}>
            <ListCard />
          </Col>
        </Row>
        <Row gutter={40}>
          <Col className="gutter-row" span="8">
            <h3>Top People:</h3>
            <UserItem />
            <UserItem />
            <UserItem />
            <UserItem />
            <UserItem />
            <UserItem />
          </Col>
          <Col className="gutter-row" span="16">
            <h3>Top performing lists</h3>
            <Row gutter={56}>
              <Col className="gutter-row" xs={24} sm={12} md={8} lg={8} xxl={6}>
                <ListCardTwo />
              </Col>
              <Col className="gutter-row" xs={24} sm={12} md={8} lg={8} xxl={6}>
                <ListCardTwo />
              </Col>
              <Col className="gutter-row" xs={24} sm={12} md={8} lg={8} xxl={6}>
                <ListCardTwo />
              </Col>
              <Col className="gutter-row" xs={24} sm={12} md={8} lg={8} xxl={6}>
                <ListCard />
              </Col>
              <Col className="gutter-row" xs={24} sm={12} md={8} lg={8} xxl={6}>
                <ListCard />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Wrapper>
  );
};

export default Audience;

const Wrapper = styled.div`
  .asset-name {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    float: left;
    max-width: 700px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 445px;
    }
  }
  .name {
    color: rgb(155, 155, 155);
    position: relative;
    float: left;
    display: flex;
    align-items: center;

    .tooltip {
      position: relative;
      display: inline-block;
      opacity: 1;
      z-index: 0;
      .tooltiptext {
        color: #ffffff;
        font-size: 11px;
        letter-spacing: 0.02px;
        line-height: 15px;
        text-align: center;
        background-color: #263153;
        visibility: hidden;
        border-radius: 4px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.3s;
        padding: 5px 10px;
        &:after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #263153 transparent transparent transparent;
        }
      }
      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
    .asset-name {
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      float: left;
      max-width: 700px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 445px;
      }
    }
    &.editable-active {
      .editable {
        display: block;
        min-width: 320px;
      }
    }
    .editable {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      display: none;
      label {
        display: none;
      }
      input {
        padding-right: 70px;
      }
      .save {
        position: absolute;
        top: 9px;
        right: 10px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
      .cancel {
        position: absolute;
        top: 9px;
        right: 40px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
    }
    .edit-btn {
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .scroll-Wrapper {
    height: auto;
    overflow-x: hidden;
    @media all and (max-height: 780px) {
      max-height: 315px;
    }
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      display: none;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .create-campaign-wrapper {
    padding: 0px 9px 0px 9px;
    position: relative;
    .create-campaign-heading {
      color: #424b50;
      font-size: 46px;
      font-weight: 800;
      line-height: 48px;
      margin-bottom: 0px;
      display: block;
      font-family: "Roboto Slab", serif;
      width: 250px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 32px;
        line-height: 40px;
      }
    }
    .edit-wrapper {
      display: flex;
      margin-top: 50px;
      margin-bottom: 48px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .new-campaign {
        color: #9b9b9b;
        font-size: 22px;
        line-height: 47px;
        margin-bottom: 0px;
        display: inline-block;
        font-family: "Roboto Slab", serif;
      }
      .edit-icon {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  .add-words-wrapper {
    .wrapper-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .add-word-head {
        color: #5e7079;
        font-size: 20px;
        margin-bottom: 0px;
        font-family: "Roboto", sans-serif;
        font-weight: 600;
        display: inline-block;
      }
      .sub-text {
        font-size: 14px;
        margin-left: 3px;
        font-weight: 600;
        opacity: 0.4;
        color: rgba(0, 0, 0, 0.85);
      }
      .test {
        font-weight: bold;
        font-size: 12px;
        color: #27ce0a;
        border: 1px solid #27ce0a;
        padding: 2px 8px;
        border-radius: 6px;
        cursor: pointer;
        letter-spacing: 1px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
          border-radius: 4px;
        }
      }
    }
    .search-input {
      padding: 10px 18px;
      font-size: 16px;
      line-height: 20px;
    }
    .dec-paragraph {
      color: #5e7079;
      font-size: 14px;
      margin-bottom: 0px;
      font-family: "Roboto", sans-serif;
      font-weight: 600;
      margin-top: 10px;
      opacity: 0.6;
      &.mb {
        margin-bottom: 80px;
      }
    }
  }
`;
